/* eslint react/forbid-prop-types:0 */

import React from "react";
import PropTypes from "prop-types";
import SearchResult from "./SearchResult";

const RecentSearchResults = ({
  Title,
  Results,
  handleSearchDelete,
  handlePlatformSelect
}) => (
  <div className="next-bus__list">
    {Results.length ? (
      <div>
        <div> {Title} </div>
        <ul className="list">
          {Results.map(result => (
            <SearchResult
              key={result.PlatformTag}
              handlePlatformSelect={handlePlatformSelect}
              PlatformName={result.PlatformName}
              PlatformNo={result.PlatformNo}
              PlatformTag={result.PlatformTag}
              RouteNos={result.RouteNos}
            />
          ))}
        </ul>
        <button
          className="btn-link btn-link--white"
          type="button"
          onClick={handleSearchDelete}
        >
          Delete all previous searches
        </button>
      </div>
    ) : (
      <div>
        You have not yet selected any stops - please search for a stop by
        entering a street name
      </div>
    )}
  </div>
);

RecentSearchResults.defaultProps = {
  Title: "",
  Results: []
};

RecentSearchResults.propTypes = {
  Title: PropTypes.string,
  Results: PropTypes.array,
  handlePlatformSelect: PropTypes.func.isRequired,
  handleSearchDelete: PropTypes.func.isRequired
};

export default RecentSearchResults;
